import { Placeholder } from 'components';
import { FC } from 'react';

type TProps = {};

export const BasketballScreen: FC<TProps> = () => {
	return <Placeholder title="Basketball 🏀" />;
};
